import * as React from 'react';
const SvgPersonCircleFilled = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M12 3a9 9 0 1 0 .001 18.001A9 9 0 0 0 12 3M9.61 8.49c.24-.45.58-.81 1-1.08S11.49 7 12 7s.98.14 1.39.41q.615.405.99 1.08c.25.45.37.94.37 1.48 0 .58-.12 1.09-.36 1.55q-.36.69-.99 1.08c-.42.27-.89.4-1.41.4s-.99-.13-1.4-.4-.74-.63-.98-1.08-.36-.97-.36-1.55c0-.54.11-1.03.36-1.48M12 19c-2.19 0-4.15-1.01-5.43-2.59 1.6-1.22 3.45-1.91 5.43-1.91s3.83.7 5.43 1.91A6.98 6.98 0 0 1 12 19"
    />
  </svg>
);
export default SvgPersonCircleFilled;
